import { Component, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from '@angular/core';
import { ProformaDetalle } from '../../../models/ProformaDetalle';
import { Proforma } from '../../../models/Proforma';
import { ProformaService } from '../../../services/operaciones/proforma/proforma.service';
import { FormControl, FormGroup } from '@angular/forms';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { ProspectosService } from '../../../services/operaciones/prospectos/prospectos.service';
import { FiltrosProspecto } from 'app/models/FiltrosProspecto';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from 'app/models/messages';
import { environment } from 'environments/environment';

declare var $: any;
@Component({
  selector: 'app-proforma-detalle',
  templateUrl: './proforma-detalle.component.html',
  styleUrls: ['./proforma-detalle.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesStatus]
})
export class ProformaDetalleComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  @ViewChild('observacionesItem', { static: false }) observacionesItem: ElementRef;
  @Output() cerrarProformaDetalle: EventEmitter<boolean> = new EventEmitter();
  @Input() idProforma: number;
  //@Input() flagEvaluarProforma: boolean;
  Proforma: Proforma = new Proforma();
  ProformaDetalle: ProformaDetalle[] = [];
  ProformaDet: any = [];
  loading: boolean;
  prospectoLoaded: boolean = false;
  contratoMarcoLoaded: boolean = false;
  adjuntosLoaded: boolean = false;
  tituloProforma: string = 'Proforma';
  tipoServicio: number = this.Id_Factoring;

  ProformaTotales: any = {
    VNPP: 0,
    Adelanto: 0,
    Interes: 0,
    Comision: 0,
    IGV_TOTAL: 0,
    Desembolso: 0,
    Remanente: 0,
  };

  //itemsProspecto: ItemsProspecto[] = [];
  //itemProspectoOtros: ItemsProspecto = new ItemsProspecto();
  //arrProspectoProforma: ItemsProspectoProforma[] = [];
  //iProspectoProforma: ItemsProspectoProforma = new ItemsProspectoProforma();
  DTOFiltrosProspecto: FiltrosProspecto = new FiltrosProspecto();
  prospecto: any[] = [];
  form: FormGroup;
  user: any;
  contratoMarco: any[] = [];
  vencido: boolean;
  documentosAdjuntos: any[] = [];
  //itemsProspectoEvaluacion: any[] = [];

  constructor(
    private simuladorService: ProformaService,
    private proformaService: ProformaService,
    private empresasService: EmpresasService,
    private prospectoService: ProspectosService,
    private msgTitle: MessagesTitles,
    private msgStatus: MessagesStatus,
    private datePipe: DatePipe
  ) {
    this.DTOFiltrosProspecto.FechaIni = this.datePipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(moment(), 'yyyy-MM-dd');

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.form = new FormGroup({
      idProforma: new FormControl(),
      observaciones: new FormControl(),
      itemsProspectoProforma: new FormControl(),
      Estado: new FormControl('R'),
      Estado_Prospecto: new FormControl('N'),
      NombreAdquirente: new FormControl(''),
      NombreProveedor: new FormControl(''),
      Num_Doc_Identificacion_Adq: new FormControl(''),
      Num_Doc_Identificacion_Prov: new FormControl(''),
      Alta_Usuario: new FormControl(this.user.Nombre),
      Email_Usuario: new FormControl(this.user.Email)
    });
  }

  ngOnInit() {
    this.cargaListados();
  }

  cargaListados() {
    this.ObtenerProforma();
    this.ObtenerProformaDetalle();

  }

  /*
  obtenerProspecto() {
    this.DTOFiltrosProspecto.idPros = 0;
    this.DTOFiltrosProspecto.FechaIni = this.datePipe.transform(this.DTOFiltrosProspecto.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(this.DTOFiltrosProspecto.FechaFin, 'yyyy-MM-dd');

    this.prospectoService.obtenerProspecto(this.DTOFiltrosProspecto).subscribe(
      (resProspecto: any) => {
        this.prospecto = resProspecto;
        this.prospecto = this.prospecto.filter(p => p.idProspecto == Number(this.Proforma.idProspecto));
        this.prospectoLoaded = true;
      },
      errP => {
        console.error({ errP });
        this.prospectoLoaded = true;
      }
    );
  }

  obtenerItemsProspecto(idProforma?: number) {
    this.simuladorService.obtenerItemsProforma(idProforma).subscribe(
      (resItemsProspecto: ItemsProspecto[]) => {
        this.itemsProspecto = resItemsProspecto;
        this.itemProspectoOtros = this.itemsProspecto.find((ipo: ItemsProspecto) => ipo.Nombre_Item == 'Otros');
        this.itemsProspecto = this.itemsProspecto.filter((ip: ItemsProspecto) => ip.Estado == 'A' && ip.Nombre_Item != 'Otros');
        this.itemsProspecto.map(p => {
          p.placeholderItem = 'Observaciones para '.concat(p.Nombre_Item.toLowerCase())
          idProforma ? p.checked = true : false
        });

        if (this.itemProspectoOtros != undefined) {
          this.itemProspectoOtros.placeholderItem = 'Observaciones adicionales';
          this.itemProspectoOtros.checked = idProforma ? true : false;
        }
      },
      err => {
        console.error({ err });
      }
    );
  }

  obtenerContratosMarco(idEmpresa, tipoServicio) {
    this.empresasService.obtenerContratosMarco(idEmpresa, tipoServicio).subscribe(
      (resContratosMarco: any) => {
        this.contratoMarco = resContratosMarco ? resContratosMarco[0] : [];
        if (this.contratoMarco == undefined) {
          this.contratoMarco = [];
        }
        this.contratoMarcoLoaded = true;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.contratoMarcoLoaded = true;
        this.loading = false;
        err.error instanceof ErrorEvent;
        if (err.error.code == 500) {
          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  obtenerDocumentoAdjuntos() {
    this.empresasService.obtenerAdjuntosEmpresa(this.Proforma.idProveedor).subscribe(
      (resDocAdjuntos: any) => {
        this.documentosAdjuntos = resDocAdjuntos;
        this.adjuntosLoaded = true;
      },
      (err: HttpErrorResponse) => {
        this.adjuntosLoaded = true;
        if (err.error instanceof ErrorEvent) {
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitle.Error,
          text: "ADJUNTOS NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }
  */

  verAdjunto(url: string) {
    window.open(url, '_blank');
  }

  MetcerrarProformaDetalle() {
    this.cerrarProformaDetalle.emit();
  }

  ObtenerProforma() {
    this.loading = true;
    this.simuladorService.obtenerProforma(this.idProforma).subscribe(
      (resProforma: Proforma) => {
        this.Proforma = resProforma;
        this.form.get('observaciones').setValue(this.Proforma.Observaciones ? this.Proforma.Observaciones : '');
        this.loading = false;

      },
      err => {
        console.error({ err });
        this.loading = false;
      }
    );
  }

  ObtenerProformaDetalle() {
    this.loading = true;
    this.simuladorService.obtenerProformaDetalle(this.idProforma).subscribe(
      (resProformaDetalle: ProformaDetalle[]) => {
        this.ProformaDetalle = resProformaDetalle;
        this.CalcularTotales();
      },
      err => {
        console.error({ err });
        this.loading = false;
      }
    );
  }

  CalcularTotales() {
    let TotalVNPP: number = 0;
    let TotalAdelanto: number = 0;
    let TotalIGV: number = 0;
    let TotalInteres: number = 0;
    let TotalComision: number = 0;
    let TotalDesembolso: number = 0;
    let TotalRemanente: number = 0;

    for (let item of this.ProformaDetalle) {
      TotalVNPP += Number(item.VNPP);
      TotalAdelanto += Number(item.Adelanto_importe);
      TotalInteres += Number(item.Interes_importe);
      TotalComision += Number(item.Comision_importe);
      TotalIGV += Number(item.IGV_Importe);
      TotalDesembolso += Number(item.Desembolso_importe);
      TotalRemanente += Number(item.Remanente_importe);

    }

    this.ProformaTotales.VNPP = TotalVNPP;
    this.ProformaTotales.Adelanto = TotalAdelanto;
    this.ProformaTotales.Interes = TotalInteres;
    this.ProformaTotales.Comision = TotalComision;
    this.ProformaTotales.IGV_TOTAL = TotalIGV;
    this.ProformaTotales.Desembolso = TotalDesembolso;
    this.ProformaTotales.Remanente = TotalRemanente;
  }

  /*
  evaluarProforma(tipoOperacion: string) {
    Swal.fire({
      title: '',
      text: tipoOperacion == 'aceptar' ? '¿Está seguro en querer aceptar la proforma?' : '¿Está seguro en querer rechazar la proforma?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        });

        Swal.showLoading();
        this.armarBodyEvaluacion(tipoOperacion, this.arrProspectoProforma);
        //return;

        this.proformaService.actualizarProforma(this.form.getRawValue()).subscribe(
          resActualizacionProforma => {
            console.log({ resActualizacionProforma });
            Swal.fire({
              title: '¡Evaluación completada!',
              text: 'El documento ha sido evaluado exitosamente.',
              type: 'success',
              heightAuto: false
            }).then((result) => {
              if (result.value) {
                this.MetcerrarProformaDetalle();
              }
            });
          },
          err => {
            console.error({ err });
            Swal.fire({
              title: 'Error',
              text: 'No se pudo evaluar el documento.',
              type: 'error',
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );
      }
    });
  }

  cambiarEstadoItem(item) {
    let itemsFinal: any = [];
    let itemsProforma: ItemsProspectoProforma = new ItemsProspectoProforma();
    this.itemsProspecto.map(p => {
      if (p.idItemsProspecto == item.idItemsProspecto) {
        p.checked = !p.checked;
        itemsFinal.push(p);
      }
    });
    
    itemsProforma.idItems_Prospecto = itemsFinal[0].idItemsProspecto;
    itemsProforma.idProforma = Number(this.Proforma.idProforma);
    itemsProforma.Observaciones = null;
    itemsProforma.checked = itemsFinal[0].checked;

    if (this.arrProspectoProforma.length > 0) {
      let elemento = this.arrProspectoProforma.find(ap => ap.idItems_Prospecto == itemsProforma.idItems_Prospecto);

      if (elemento != undefined) {
        this.arrProspectoProforma.splice(this.arrProspectoProforma.indexOf(elemento), 1);
      } else {
        this.arrProspectoProforma.push(itemsProforma);
      }

    } else {
      this.arrProspectoProforma.push(itemsProforma);
    }

  }

  cambiarEstadoItemOtros() {
    let itemsFinalOtros: any = [];
    let itemsProformaOtros: ItemsProspectoProforma = new ItemsProspectoProforma();
    this.itemProspectoOtros.checked = !this.itemProspectoOtros.checked;
    itemsFinalOtros.push(this.itemProspectoOtros);
    itemsProformaOtros.idItems_Prospecto = itemsFinalOtros[0].idItemsProspecto;
    itemsProformaOtros.idProforma = Number(this.Proforma.idProforma);
    itemsProformaOtros.Observaciones = '';
    itemsProformaOtros.checked = itemsFinalOtros[0].checked;

    if (this.arrProspectoProforma.length > 0) {
      let elemento = this.arrProspectoProforma.find(ap => ap.idItems_Prospecto == itemsProformaOtros.idItems_Prospecto);

      if (elemento != undefined) {
        this.arrProspectoProforma.splice(this.arrProspectoProforma.indexOf(elemento), 1);
      } else {
        this.arrProspectoProforma.push(itemsProformaOtros);
      }

    } else {
      this.arrProspectoProforma.push(itemsProformaOtros);
    }

  }

  armarBodyEvaluacion(tipoOperacion, array) {
    this.form.get('idProforma').setValue(this.Proforma.idProforma);
    this.form.get('Estado_Prospecto').setValue(tipoOperacion == 'aceptar' ? 'A' : 'R');
    array.map(item => {
      if (item.Observaciones != null) {
        item.Observaciones = this.observacionesItem.nativeElement.value;
      }
    });
    this.form.get('itemsProspectoProforma').setValue(this.arrProspectoProforma);
    this.form.get('NombreAdquirente').setValue(this.Proforma.NombreAdquirente);
    this.form.get('NombreProveedor').setValue(this.Proforma.NombreProveedor);
    this.form.get('Num_Doc_Identificacion_Adq').setValue(this.Proforma.Num_Doc_Identificacion_Adq);
    this.form.get('Num_Doc_Identificacion_Prov').setValue(this.Proforma.Num_Doc_Identificacion_Prov);
    console.log("this.form.getRawValue(): ", this.form.getRawValue());

  }
  */
}